import { CAPPENDIX_STATUS_READY, ContractAppendixStatus, DownloadFileDto } from '@sr/dto';
import { ContractAppendixDto, UpdateContractAppendixDto } from '@sr/dto/dist/src/contract-appendix.dto';
import { FormTools } from 'utils/form-tools';
import { FormikErrors } from 'formik';


export type FormValues = {
  status: ContractAppendixStatus | '',
  date: Date | '',
  scanFile: DownloadFileDto[] | null,
  extraConditionsText: string,
  promoFile: DownloadFileDto[] | null,
};

export const formTools: FormTools<ContractAppendixDto, void, UpdateContractAppendixDto, FormValues> = {
  toCreateDto: formData => null,

  toUpdateDto: (id, formData) => ({
    id: id,
    status: formData.status as ContractAppendixStatus,
    date: new Date(formData.date),
    extraConditionsText: formData.extraConditionsText,
    scanFileId: formData.scanFile?.length ? formData.scanFile[0].id : null,
    scanFiles: formData.scanFile ?? [],
    promoFileId: formData.promoFile?.length? formData.promoFile[0].id : null,
    promoFiles: formData.promoFile ?? []
  }),

  fromDto: (dto) => ({
    status: dto.status,
    date: dto.date,
    extraConditionsText: dto.extraConditionsText,
    scanFile: dto?.scanFiles ?? (dto?.scanFile ? [dto.scanFile] : null),
    promoFile: dto?.promoFiles ?? (dto?.promoFile ? [dto.promoFile] : null)
    // promoFile: dto.promoFile,
  }),

  validate: (values: FormValues): FormikErrors<FormValues> => {
    let validationResult: FormikErrors<FormValues> = {};

    // if (!values.managerId)
    //   validationResult.managerId = VALIDATION_REQUIRED_FIELD;


    // if (!values.startDate)
    //   validationResult.startDate = VALIDATION_REQUIRED_FIELD;
    // else
    //   validateDateField('startDate', values, validationResult);

    // if (!values.unlimited) {
    //   if (values.endDate === '')
    //     validationResult.endDate = VALIDATION_REQUIRED_FIELD;
    //   else
    //     validateDateField('endDate', values, validationResult);
    // }

    // if (values.startDate && values.endDate)
    //   if (isBefore(values.endDate, values.startDate)) {
    //     validationResult.startDate = 'Дата начала не может быть больше конца';
    //     validationResult.endDate = 'Дата начала не может быть больше конца';
    //   }


    // if (isNaN(Number(values.wccCost)))
    //   validationResult.wccCost = 'Допустимы только числовые значения';

    return validationResult;
  },
  emptyValues: () => ({
    date: new Date(),
    extraConditionsText: '',
    status: CAPPENDIX_STATUS_READY,
    scanFile: null,
    promoFile: null
  })
};
